/* esm.sh - accessor-fn@1.5.3 */
export * from "/*accessor-fn@1.5.3/esnext/accessor-fn.mjs";
export { default } from "/*accessor-fn@1.5.3/esnext/accessor-fn.mjs";
